/**
 * Assist mode — a salesperson / admin / major admin / super admin can "log in
 * for" a walk-in or regular customer by phone number. While assist mode is on,
 * checkouts and karigar jobs they create are linked to that customer's phone,
 * so the customer sees the order and the karigar workflow updates in their own
 * dashboard (karigar identity hidden).
 */
const KEY = "sg_assist";
const EVENT = "sg-assist-changed";

export const assistGet = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
};

export const assistStart = (phone, name = "") => {
  localStorage.setItem(KEY, JSON.stringify({ phone, name, started_at: new Date().toISOString() }));
  window.dispatchEvent(new Event(EVENT));
};

export const assistEnd = () => {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVENT));
};

export const assistSubscribe = (fn) => {
  window.addEventListener(EVENT, fn);
  window.addEventListener("storage", fn);
  return () => { window.removeEventListener(EVENT, fn); window.removeEventListener("storage", fn); };
};
